export enum ModuleDefinitionKind {
  /** A dynamic module definition that is created for a specific entry.
   * This kind requires an entry upon creation and is tied to that entry.
   * If another entry needs the same module instance tied to it, a new dynamic module instance must be created for that entry first.
   */
  DYNAMIC = "DYNAMIC",
  /** A fixed module definition that does not change once created.
   * This kind can be created without an entry and can, later, be assigned to multiple entries.
   */
  FIXED = "FIXED",
}
